
    <recycle-scroller :items="items" id="scroller" key-field="key" :item-size="170" v-slot="{ item }">
        <b-container>
            <b-row>
                <b-col class="image-tile" cols="4" v-for="(id, index) in item.ids" :key="String(id)">
                    <img v-if="Array.isArray(id)" class="bound-preview" :src="show_preview_document(id[id.length - 1])"
                        @click="unbind(compute_global_index(item.key, index))" />
                    <b-badge class="badge" v-if="Array.isArray(id)">{{
                            id.length
                    }}</b-badge>
                    <img v-else :class="{
                        preview: true,
                        pre_selected: pre_selected(
                            compute_global_index(item.key, index)
                        ),
                    }" :src="show_preview_document(id)" @mouseover="
    hover(compute_global_index(item.key, index))
" @click="
    bind_item(compute_global_index(item.key, index))
" />

                    <div class="incoherence"
                        v-if="Array.isArray(id) && indexesOfIncoherentBoundDocuments.includes(compute_global_index(item.key, index))">
                        ⚠️
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </recycle-scroller>
